<div class="dialog">
  <div class="dialog-main">
    <div class="dialog-header">
      {{'OTP Verification'|lang:'otpVerificationHead':utils.langData}}
    </div>
    <div class="dialog-body">
      <div class="col-12 ">
        <span class="note-text" *ngIf="config.isMobileNotVerified && !config.isEmailNotVerified">{{'Verify your Mobile Number with the OTP sent.'|lang:'otpVerificationTitle2':utils.langData}}</span>
        <span class="note-text p-0" *ngIf="!config.isMobileNotVerified && config.isEmailNotVerified">{{'Verify your Email Address with the OTP sent.'|lang:'otpVerificationTitle3':utils.langData}}</span>
        <span class="note-text" *ngIf="config.isMobileNotVerified && config.isEmailNotVerified">{{'Verify your Mobile Number and Email Address with the separate OTPs sent.'|lang:'otpVerificationTitle1':utils.langData}}</span>
      </div>
      <form [formGroup]="formGroup" class="{{
        config.getMobileOtp && config.mobileVerified ? '' : 'row'
      }}">
        <div class="col-sm-6" *ngIf="(!config.getMobileOtp || (config.getMobileOtp && !config.mobileVerified))" >
          <ng-container >
            <div class="otp-wrap mb-4" [hidden]="config.mobileVerified">
              <label for="otp"
                class="control-label otp-label">{{'Received OTP on Mobile'|lang:'mobileOtpFldLbl':utils.langData}} <span class="email ml-1 mr-1">{{utils.getSessionStorageValue('obMobile_no')}}<img src="../../../assets/images/edit.png" (click)="cancelOTPVerify()" height="13" width="13"></span></label>
              <div class="form-group otp mt-1" [hidden]="config.mobileVerified"
                [class.validation-error]="formGroup?.get('mobOtp').invalid && formGroup?.get('mobOtp').dirty">
                <input autocomplete="one-time-code" type="text" class="form-control" inputRestrict="unsignedInteger" maxlength="6"
                  inputmode="numeric" formControlName="mobOtp" id="mobOtp"
                  [disabled]="config.mobileVerified" [ngClass]="{'has-value' : formGroup?.get('mobOtp').value}" />
              </div>
              <div *ngIf="formGroup?.get('mobOtp').dirty && formGroup?.get('mobOtp').invalid" class="text-center">
                <small class="text-danger"
                  *ngIf="formGroup?.get('mobOtp').hasError('required')">{{config.routeInfo?.inputs?.mobOtp.error.required}}</small>
                <small class="text-danger"
                  *ngIf="formGroup?.get('mobOtp').hasError('pattern')">{{config.routeInfo?.inputs?.mobOtp.error.pattern}}</small>
              </div>
            </div>
            <div class=" text-center resend-container mb-5 mb-sm-0" id="resend-mobile" [hidden]="config.mobileVerified">
              <a *ngIf="config?.mobSubscription?.closed" href="Javascript:void(0);" class=""
                (click)="sendOnboardOTP(formValues?.mobileNumber || investor.investorDetailsDtoList[0]?.mobileNum, null, true)">{{'Resend OTP on Mobile'|lang:'resendotpcall':utils.langData}}</a>
              <span *ngIf="!config?.mobSubscription?.closed" class="">{{'Retry in'|lang:'retryin':utils.langData}}
                {{config?.mobValue<10?'0'+config?.mobValue:config?.mobValue}} second(s)</span>
            </div>
          </ng-container>
          <div class="text-center text-success" *ngIf="config.mobileVerified">
            {{'Mobile Verfied Successfully.'|lang:'mobileverifysuccess':utils.langData}}
          </div>
        </div>
        <div class="{{config.getMobileOtp && config.mobileVerified ? 'mt-sm-0 mt-1' : 'col-sm-6 mt-sm-0 mt-1'}}" >
          <ng-container>
            <div class="otp-wrap mb-4" [hidden]="config.emailVerified">
              <label for="otp"
                class="control-label otp-label">{{'Received OTP on Email  '|lang:'emailOtpFldLbl':utils.langData}} <span class="email ml-1 mr-1">{{utils.getSessionStorageValue('obEmail_id')}}<img src="../../../assets/images/edit.png" (click)="cancelOTPVerify()" height="13" width="13"></span> </label> 
              <div class="form-group otp mt-1" [hidden]="config.emailVerified"
                [class.validation-error]="formGroup?.get('emailOtp').invalid && formGroup?.get('emailOtp').dirty">
                <input autocomplete="off" type="text" class="form-control" inputRestrict="unsignedInteger" maxlength="6"
                  inputmode="numeric" formControlName="emailOtp" id="emailOtp" autocomplete="off"
                  [disabled]="config.emailVerified" [ngClass]="{'has-value' : formGroup?.get('emailOtp').value}" />
              </div>
              <div *ngIf="formGroup?.get('emailOtp').dirty && formGroup?.get('emailOtp').invalid" class="text-center">
                <small class="text-danger"
                  *ngIf="formGroup?.get('emailOtp').hasError('required')">{{config.routeInfo?.inputs?.emailOtp.error.required}}</small>
                <small class="text-danger"
                  *ngIf="formGroup?.get('emailOtp').hasError('pattern')">{{config.routeInfo?.inputs?.emailOtp.error.pattern}}</small>
              </div>
            </div>
            <!-- <div class="text-center resend-container " id="resend-email" [hidden]="config.emailVerified">
              <a *ngIf="config?.emailSubscription?.closed" href="Javascript:void(0);" class="btn btn-resend btn-sm"
                (click)="sendOnboardOTP(null,formValues?.email|| investor.investorDetailsDtoList[0]?.emailID, true)">{{'RESEND OTP ON EMAIL'|lang:'resendotpmail':utils.langData}}</a>
              <span class="btn btn-resend btn-sm" *ngIf="!config?.emailSubscription?.closed">{{'Retry in'|lang:'retryin':utils.langData}}
                {{config?.emailValue < 10?'0'+config?.emailValue:config?.emailValue}} second(s)</span>
            </div> -->
          </ng-container>
          <div class=" text-center text-success" *ngIf="config.emailVerified">
            {{'Email Verfied Successfully.'|lang:'newemailverifysuccess':utils.langData}}
          </div>
        </div>
      </form>
    </div>
    <div class="dialog-footer">
      <div class="row">
        <!-- [ngClass]="{'col-4' : currentUrl?.indexOf('review') == -1, 'auto-margin': currentUrl?.indexOf('review') > -1}" -->
      
        <!-- *ngIf="currentUrl?.indexOf('review') == -1" -->
            
        <!-- cancel btn commented -->
        <!-- <div class="col-4">
          <button type="button" class="btn btn-o col-md-12" appRipple (click)="cancelOTPVerify()">
            <span>{{'Cancel'|lang:'cancelBtnLbl':utils.langData}}</span>
          </button>
        </div> -->


        <!-- <div class="col-4" *ngIf="!utils?.otpFormModal?.showProceed && businessInfo!=='MF'" >
          <button type="button" class="btn btn-secondary col-md-12" appRipple (click)="skipForm()">
            <span>{{'Do it Later'|lang:'laterBtnLbl':utils.langData}}</span>
          </button>
        </div> -->

        <div class="col-10 col-md-6 text-center"  *ngIf="!utils?.otpFormModal?.showProceed">
          <button type="button" class="verifybtn btn btn-gradient col-md-12 mb-3"
            [disabled]="formGroup?.invalid || (config.isMobileNotVerified && !formGroup?.get('mobOtp')?.value)|| (config.isEmailNotVerified && !formGroup?.get('emailOtp')?.value)"
            appRipple (click)="verifyOTP(formGroup?.get('mobOtp').value,formGroup?.get('emailOtp').value)">
            <span>{{'Verify'|lang:'verifyBtnLbl':utils.langData}}</span>
          </button>
          <div class="d-flex justify-content-between">
            <div (click)="skipForm()">
              <a class="do-later">{{'Do it Later'|lang:'laterBtnLbl':utils.langData}}</a>
            </div>
            <div class="text-center resend-container " id="resend-email" [hidden]="config.emailVerified">
                <a *ngIf="config?.emailSubscription?.closed" href="Javascript:void(0);" class="resendbtn"
                  (click)="sendOnboardOTP(null,formValues?.email|| investor.investorDetailsDtoList[0]?.emailID, true)">{{'Resend OTP On Email'|lang:'resendotpmail':utils.langData}}</a>
                <span class="" *ngIf="!config?.emailSubscription?.closed">{{'Retry in'|lang:'retryin':utils.langData}}
                  {{config?.emailValue < 10?'0'+config?.emailValue:config?.emailValue}} second(s)</span>
              </div>
          </div>
         
        </div>

        <div *ngIf="utils?.otpFormModal?.showProceed">

          <button type="button" class="btn btn-gradient col-md-12"
            [disabled]="formGroup?.invalid || (config.isMobileNotVerified && !formGroup?.get('mobOtp')?.value)|| (config.isEmailNotVerified && !formGroup?.get('emailOtp')?.value)"
            appRipple (click)="verifyOTP(formGroup?.get('mobOtp').value,formGroup?.get('emailOtp').value,true)">
            <span>{{'verify & Proceed'|lang:'verifynproced':utils.langData}}</span>
          </button>

          <div class="d-flex justify-content-between">
            <div class="text-center resend-container " id="resend-email" [hidden]="config.emailVerified">
                <a *ngIf="config?.emailSubscription?.closed" href="Javascript:void(0);" class="resendbtn"
                  (click)="sendOnboardOTP(null,formValues?.email|| investor.investorDetailsDtoList[0]?.emailID, true)">{{'Resend OTP On Email'|lang:'resendotpmail':utils.langData}}</a>
                <span class="" *ngIf="!config?.emailSubscription?.closed">{{'Retry in'|lang:'retryin':utils.langData}}
                  {{config?.emailValue < 10?'0'+config?.emailValue:config?.emailValue}} second(s)</span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
